import React from 'react';
import PropTypes from 'prop-types';
import Text from '../containers/Text';
import IconButton from './IconButton';
import Icon from './Icon';

// //www.myhermes.de/paketshop/hermes-paketshop-{paketshopName}-{paketshopOrt}/{paketexternalId}
const DetailLink = ({asLink, onClick, shop, isPaketParcelLock, isDetailLinkOnMap, isDetailLinkOnList}) => {
  if (asLink) {
    return (
      <a href={`//www.myhermes.de/paketshop/hermes-paketshop-${shop.description || shop.name}-${shop.city}/${shop.parcelShopNumber}`}
         target='_blank'
         className='btn btn-link btn-sm'>
            <Icon icon='share' /> {' '}
            <Text id='details' />
      </a>
    );
  }

  return (
    <IconButton text='details' icon='share'
        onClick={() => {
            onClick(shop.parcelShopNumber);

            if (isDetailLinkOnList) {
                window.wts.push(['send', 'click', {linkId: 'Liste.Details'}]); //bei Klick auf Details
            }
            if (isDetailLinkOnMap) {
                window.wts.push(['send', 'click', {linkId: 'Karte.Details'}]); //bei Klick auf Details-Link
            }
            if (isPaketParcelLock) {
                window.wts.push(['send', 'click', {linkId: 'Sendungsverfolgung'}]); //nur bei Parcellock, sonst ist link nicht sichtbar
            }
        }}/>
  );
}

DetailLink.propTypes = {
    parcelShopNumber: PropTypes.string.isRequired,
    isPaketParcelLock: PropTypes.bool.isRequired,
    isDetailLinkOnMap: PropTypes.bool.isRequired,
    isDetailLinkOnList: PropTypes.bool.isRequired
};


export default DetailLink;
